export enum IrisModalSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}
